<template>
  <div>
    <nav-bar></nav-bar>
    <div style="height: 13.056vw;"></div>
    <div class="errPage">
      <div class="h5-container">
        <div class="h5_img">
          <img src="@/assets/error_404.png" alt="">
        </div>
        <div class="h5__desc">
          <span>Σ(oﾟдﾟoﾉ) 无法找到该页面~</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/common/NavBar";

export default {
  name: "ErrorNotfound",
  components: {
    NavBar
  }
}
</script>

<style scoped lang="scss">
.errPage {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 13.056vw); /* Adjust according to your layout */
  .h5-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .h5_img {
    width: 100%; /* Make sure the image takes up the full width of the container */
    max-width: 300px; /* Restrict the maximum width of the image */
    img {
      width: 100%; /* Ensure the image scales down to fit its container */
    }
  }
  .h5__desc {
    color: #a0a0a0;
    text-align: center;
    margin-top: 20px; /* Add some space between the image and the description */
  }
}
</style>
